import { get, post } from '@/base/http-base.js'
import { getLang } from '@/utils'
const isEn = getLang() === 'en-US'
let channel = getLang() === 'en-US' ? 'News_en' : 'News'
//app-新闻-首页
export function describeNavigatorsApi(params) {
  return get(`/v1/form/pc/news/navigator?channel=News`, params)
}
//app-新闻-资讯列表
export function getListApi(params) {
  params.channel = channel
  params.cls = isEn ? params.cls + '_en' : params.cls
  return get('/v1/form/pc/news/list', params)
}
//app-新闻-资讯详情
export function getDetailApi(params) {
  return get('/v1/form/pc/news/detail', params)
}
//app-新闻-搜索
export function searchApi(params) {
  return get('/v1/form/pc/news/search', params)
}
//app-新闻-搜索
export function getNoticesTabApi(params) {
  return get('/v1/cms/pc/news/notices', params)
}
//pc新闻首页
export function getHomeList(params) {
  return get('/v1/form/pc/news/navigator?channel=News', params)
}
//pc咨询列表
export function getNoticeList(params) {
  params.channel = channel
  params.cls = isEn ? params.cls + '_en' : params.cls
  return get('/v1/form/pc/news/list', params)
}
//pc咨询详情
export function getNoticeDetail(params) {
  return get('/v1/form/pc/news/detail', params)
}
//pc咨询详情
export function getNoticeContentDetail(id) {
  return get(`/v1/form/pc/news/content/${id}`)
}
//pc新闻搜索
export function getNewSearch(params) {
  return get('/v1/form/pc/news/search', params)
}
//pc活动日历
export function getNewDate(params) {
  return get('/v1/news/meeting/platform/pc/list', params)
}
//pc采访通知分类
export function getNoticeClassify() {
  return get('/v1/cms/pc/news/notices')
}
//pc user信息
export function getUserApi(params) {
  return get('/getAccount', params, {
    isLogin: true
  })
}
//咨询详情-阅读量
export function getSunshinePV(params) {
  return post('/service/datacube/v1/sunshine_pv', params)
}
//user信息
export function getAccountApi(params) {
  return get('/getAccount', params, {
    isLogin: true
  })
}
//媒体登录
export function mediaLoginApi(params) {
  return post('/mediaLogin', params, {
    once: true
  })
}

export function getSecList(params) {
  return get('/v1/cms/pc/news/subCls', params, {
    once: true,
    isLogin: true
  })
}

// 获取pv
export function getPv(id) {
  return get(`/v1/form/pc/news/content-pv/${id}`)
}
